<section class="visit-section section-padding" aria-labelledby="visit-title" itemscope
  itemtype="https://schema.org/Distillery">
  <!-- METADATOS LOCAL BUSINESS / EMPRESA LOCAL GOOGLE -->
  <meta itemprop="telephone" content="+593998581721" />
  <meta itemprop="priceRange" content="$$" />
  <meta itemprop="servesCuisine" content="Cata de Destilados, Ron Añejo, Whisky Single Malt, Maridaje Ecuatoriano" />
  <meta itemprop="url" content="https://estancosdc.com/visitas" />
  <meta itemprop="currenciesAccepted" content="USD" />
  <meta itemprop="paymentAccepted" content="Cash, Credit Card, Bank Transfer" />

  <div class="container">

    <div class="visit-grid">

      <!-- Columna Imagen -->
      <div class="visit-image-wrapper">
        <!-- AEO: Atributos alt enriquecidos, lazy loading y itemprop para asociar la imagen al negocio local -->
        <img src="https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/destileriaEcommerce.jpeg"
          alt="Instalaciones de la Destilería Estancos en el Valle de los Chillos, Quito" class="visit-image"
          itemprop="image" loading="lazy" width="600" height="800">
        <div class="visit-image-overlay" aria-hidden="true"></div>
      </div>

      <!-- Columna Contenido -->
      <div class="visit-content">
        <span class="section-subtitle">Enoturismo y Catas</span>
        <h2 id="visit-title" itemprop="name">Vive la Experiencia Estancos</h2>

        <!-- AEO: Inyección de las Tripletas Semánticas con etiquetas strong para los modelos de lenguaje -->
        <div itemprop="description" class="visit-desc">
          <p>
            <strong>Destilería Estancos</strong> ofrece <strong>tours guiados en Quito</strong>.
            <strong>Los visitantes</strong> recorren <strong>nuestras instalaciones artesanales</strong> para descubrir
            la destilación de altura.
            <strong>Nuestra experiencia de enoturismo</strong> incluye <strong>catas exclusivas directamente de las
              barricas</strong>.
          </p>
        </div>

        <div class="info-container">

          <!-- AEO: Marcado Schema para Dirección Postal (Vital para SEO Local / Organización) -->
          <div class="info-block" itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
            <meta itemprop="addressCountry" content="EC" />
            <meta itemprop="postalCode" content="170804" />
            <div class="info-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
              </svg>
            </div>
            <div class="info-text">
              <h3>Ubicación</h3>
              <p>
                <span itemprop="streetAddress">Destilería Estancos, Ushimana 2</span><br>
                <span itemprop="addressLocality">Valle de los Chillos</span>, <span
                  itemprop="addressRegion">Quito</span>, <span itemprop="addressCountry">Ecuador</span> (CP: <span itemprop="postalCode">170804</span>)
              </p>
            </div>
          </div>

          <!-- AEO: Marcado Schema para Horarios de Apertura (OpeningHours) -->
          <div class="info-block">
            <div class="info-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="info-text">
              <h3>Horarios de Visita</h3>
              <p>
                <!-- La etiqueta <time> con datetime estandarizado es leída directamente por Google Maps y Search -->
                <time itemprop="openingHours" datetime="Th,Fr,Sa 12:00-18:00">Jueves a Sábado: 12:00 PM – 6:00
                  PM</time><br>
                <time itemprop="openingHours" datetime="Su 11:00-15:00">Domingo: 11:00 AM – 3:00 PM</time>
              </p>
            </div>
          </div>

        </div>

        <!-- AEO: Reemplazo de href por routerLink (Angular SPA) y adición de atributo title contextual -->
        <a routerLink="/visitas" class="btn-primary" title="Agendar tour guiado y cata en Destilería Estancos">
          Agendar Visita
          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </a>

      </div>
    </div>

  </div>
</section>